import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/wrappers/authwrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/wrappers/pageWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ColorSchemeScript"] */ "/vercel/path0/node_modules/@mantine/core/esm/core/MantineProvider/ColorSchemeScript/ColorSchemeScript.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["MantineProvider"] */ "/vercel/path0/node_modules/@mantine/core/esm/core/MantineProvider/MantineProvider.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mantine/core/styles.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mantine/dates/styles.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mantine/carousel/styles.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["closeAllModals","closeModal","modals","openConfirmModal","openContextModal","openModal","updateContextModal","updateModal"] */ "/vercel/path0/node_modules/@mantine/modals/esm/events.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["ModalsProvider"] */ "/vercel/path0/node_modules/@mantine/modals/esm/ModalsProvider.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useModals"] */ "/vercel/path0/node_modules/@mantine/modals/esm/use-modals/use-modals.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mantine/nprogress/styles.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Livvic\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":\"400\",\"style\":\"normal\"}],\"variableName\":\"livvic\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/node_modules/sonner/dist/index.mjs");
